<template>
  <BaseModal v-model="exitModal" :must-confirm="true">
    <template #header v-if="(!cart.paymentFailedTimeoutFlag && cart.paymentFailedExpire > 0)">{{ $t('checkout.leave_checkout_header') }}</template>
    <template #header v-else>{{ $t('checkout.leave_checkout_header_expired') }}</template>

    <div class="p-6">
      <div class="mb-2 font-semibold" v-if="(!cart.paymentFailedTimeoutFlag && cart.paymentFailedExpire > 0)">
        {{ $t('checkout.leave_checkout_confirmation') }}
      </div>
      <div class="mb-2 font-semibold" v-else>
        {{ $t('checkout.leave_checkout_confirmation_expired') }}
      </div>
    </div>

    <template #footer>
      <div class="flex justify-end gap-2" v-if="nextLink && (!cart.paymentFailedTimeoutFlag && cart.paymentFailedExpire > 0)">
        <BaseButton
          class="w-full md:w-auto"
          color="accent"
          @click="exitModal = false"
        >
          {{ $t('checkout.stay_in_checkout_cancel') }}
        </BaseButton>

        <BaseButton
          class="w-full md:w-auto"
          color="primary"
          @click="handleLeave"
        >
          {{ $t('checkout.leave') }}
        </BaseButton>
      </div>
      <div v-else class="flex justify-end">
        <BaseButton
          class="w-full md:w-auto"
          color="primary"
          @click="handleLeave"
        >
          {{ $t('checkout.leave') }}
        </BaseButton>
      </div>
    </template>
  </BaseModal>
</template>



<script setup lang="ts">
  import { onBeforeUnmount, onMounted, ref, watch } from 'vue';
  import { onBeforeRouteLeave, useRouter } from 'vue-router';

  import BaseButton from '@/components/ui/BaseButton.vue';
  import BaseModal from '@/components/ui/BaseModal.vue';
  import { useCartStore } from '@/stores/cart';
  import { useCheckoutStore } from '@/stores/checkoutStore';
  import { useCheckoutNavigation } from '@/utils/checkoutNavigation';
  import { closeEmbedDrawer } from '@/utils/embedNavigation';
  import { isEmbed } from '@/utils/isEmbed';

  const exitModal = ref(false);
  const preventGuard = ref(false);

  const cart = useCartStore();
  const router = useRouter();
  const checkoutStore = useCheckoutStore();
  const { shouldBlockNavigation } = useCheckoutNavigation();
  const nextLink = ref<string | null>(null);

  watch(() => checkoutStore.showCancelPaymentModal, (val) => {
    if (val) {
      nextLink.value = '/';
      exitModal.value = true;
      checkoutStore.showCancelPaymentModal = false;
    }
  });

  function handleLeave() {
    cart.cancelUnpaidOrder();
    preventGuard.value = true;
    exitModal.value = false;
    if (closeEmbedDrawer()) return;
    // console.log(nextLink.value);
    if (nextLink.value) {
      router.push(nextLink.value);
    } else {
      router.push('/');
    }
  }

  onBeforeRouteLeave((to, from) => {
    if (preventGuard.value) {
      return true;
    }

    const block = shouldBlockNavigation(to, from);
    if (block === 'cancel-payment') {
      exitModal.value = true;
      nextLink.value = to.fullPath;
      return false;
    }
    return true;
  });

  onMounted(() => {
    window.addEventListener('beforeunload', handleBeforeUnload);
  });
  onBeforeUnmount(() => {
    window.removeEventListener('beforeunload', handleBeforeUnload);
  });

  function handleBeforeUnload(event: BeforeUnloadEvent) {
    if(isEmbed() || checkoutStore.paymentBegun || cart.isCartEmpty() || preventGuard.value || cart.ignoreCancelPaymentModal) return;
    event.preventDefault();
    event.returnValue = 'Du er ved at forlade checkout';
    exitModal.value = true;
    return 'Du er ved at forlade checkout';
  }
</script>
